export default "__VITE_ASSET__By2eui6K__"